<template>
  <div class="page-container">
    <!-- 筛选栏 -->
    <div class="filter-bar">
      <el-form :inline="true" :model="search" size="small">
        <el-form-item label="订单号"><el-input v-model="search.orderNo" placeholder="订单号" clearable style="width:150px;"></el-input></el-form-item>
        <el-form-item label="用户ID"><el-input v-model="search.customerNo" placeholder="用户ID" clearable style="width:130px;"></el-input></el-form-item>
        <el-form-item label="姓名"><el-input v-model="search.name" placeholder="姓名" clearable style="width:120px;"></el-input></el-form-item>
        <el-form-item label="客户组别">
          <el-select v-model="search.groupName" placeholder="全部" clearable style="width:130px;">
            <el-option v-for="g in groups" :key="g.groupName" :label="g.groupName" :value="g.groupName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调整类型">
          <el-select v-model="search.adjustType" placeholder="全部" clearable style="width:100px;">
            <el-option label="增额" :value="1"></el-option>
            <el-option label="减额" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="search.status" placeholder="全部" clearable style="width:100px;">
            <el-option label="待审核" :value="1"></el-option>
            <el-option label="已通过" :value="2"></el-option>
            <el-option label="已拒绝" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调整时间">
          <el-date-picker v-model="search.timeRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:260px;"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchList">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 标签页 -->
    <div class="tabs-bar">
      <button :class="['tab-btn', {active: activeTab==='all'}]" @click="switchTab('all')">全部 ({{ stats.all || 0 }})</button>
      <button :class="['tab-btn', {active: activeTab==='pending'}]" @click="switchTab('pending')">待审核 ({{ stats.pending || 0 }})</button>
      <button :class="['tab-btn', {active: activeTab==='passed'}]" @click="switchTab('passed')">已通过 ({{ stats.passed || 0 }})</button>
      <button :class="['tab-btn', {active: activeTab==='rejected'}]" @click="switchTab('rejected')">已拒绝 ({{ stats.rejected || 0 }})</button>
    </div>

    <!-- 表格 -->
    <div class="table-wrapper">
      <div class="table-header">
        <span class="table-title">额度调整记录</span>
        <div class="table-actions">
          <button v-auth="'payment:creditAdjustment:add'" class="btn btn-primary btn-sm" @click="openAddModal">+ 额度调整</button>
          <button v-auth="'payment:creditAdjustment:review'" class="btn btn-primary btn-sm" @click="batchApprove">✓ 审批</button>
          <button v-auth="'payment:creditAdjustment:review'" class="btn btn-danger btn-sm" @click="openBatchReject">✕ 拒绝</button>
          <button v-auth="'payment:creditAdjustment:export'" class="btn btn-secondary btn-sm" @click="handleExport">📥 导出</button>
        </div>
      </div>
      <el-table ref="table" :data="tableData" border v-loading="loading" style="width:100%;" @selection-change="handleSelectionChange">
        <!-- 选择列宽度必须放得下复选框：body 侧 .cell 左右各 14px 内边距（表头侧是 10px），
             35px 时复选框那行会溢出，被 Element 的 .el-table .cell{overflow:hidden;text-overflow:ellipsis}
             画成「复选框右边一串 …」（表头不溢出，所以只有数据行有）。
             这里取 42，与入金/出金管理页一致（客户审核记录页用的是 40）。align=center 让复选框居中 -->
        <el-table-column type="selection" width="42" align="center"></el-table-column>
        <el-table-column prop="orderNo" label="订单号" width="180"></el-table-column>
        <el-table-column prop="customerNo" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="name" label="姓名" width="90"></el-table-column>
        <el-table-column prop="countryName" label="国家" width="100">
          <template slot-scope="{row}">{{ row.countryName || '--' }}</template>
        </el-table-column>
        <el-table-column prop="groupName" label="客户组" width="110">
          <template slot-scope="{row}">{{ row.groupName || '--' }}</template>
        </el-table-column>
        <el-table-column label="当前额度（USD）" align="right" width="130">
          <template slot-scope="{row}"><span class="mono">{{ fmtMoney(row.currentCredit) }}</span></template>
        </el-table-column>
        <el-table-column label="调整额度（USD）" align="right" width="130">
          <template slot-scope="{row}">
            <span class="mono" :style="{color: row.adjustType===1 ? '#16a34a' : '#dc2626'}">{{ signedMoney(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="调整后额度（USD）" align="right" width="140">
          <template slot-scope="{row}"><span class="mono">{{ fmtMoney(row.afterCredit) }}</span></template>
        </el-table-column>
        <el-table-column label="调整类型" width="90">
          <template slot-scope="{row}">
            <el-tag :type="row.adjustType===1 ? 'success' : 'danger'" size="mini">{{ row.adjustTypeName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="90">
          <template slot-scope="{row}">
            <el-tag :type="statusType(row.status)" size="mini">{{ row.statusName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="160"></el-table-column>
        <el-table-column label="审核时间" width="160">
          <template slot-scope="{row}">{{ row.auditTime ? fmtDateTime(row.auditTime) : '--' }}</template>
        </el-table-column>
        <el-table-column prop="reviewer" label="操作人" width="100">
          <template slot-scope="{row}">{{ row.reviewer || '--' }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button v-auth="'payment:creditAdjustment:find'" type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
            <el-button v-if="scope.row.status === 1" v-auth="'payment:creditAdjustment:review'" type="text" size="small" style="color:var(--brand-primary);" @click="handleApprove(scope.row)">通过</el-button>
            <el-button v-if="scope.row.status === 1" v-auth="'payment:creditAdjustment:review'" type="text" size="small" style="color:#dc2626;" @click="openReject(scope.row)">拒绝</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{pageSize=v;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
    </div>

    <!-- 新增额度调整弹窗 -->
    <el-dialog :visible.sync="addVisible" width="520px" :close-on-click-modal="false" title="额度调整">
      <el-form :model="addForm" label-width="90px" size="small" :rules="addRules" ref="addForm">
        <el-form-item label="用户ID" prop="customerNo">
          <el-input v-model="addForm.customerNo" placeholder="请输入用户ID" @blur="queryAccounts"></el-input>
        </el-form-item>
        <el-form-item label="关联账号" prop="accountNo">
          <el-select v-model="addForm.accountNo" filterable clearable placeholder="请选择关联账号" style="width:100%;"
            :loading="accountLoading" :disabled="accountList.length === 0" @change="onAccountChange">
            <el-option v-for="a in accountList" :key="a.accountNo" :label="accountLabel(a)" :value="a.accountNo"></el-option>
          </el-select>
          <div v-if="!accountLoading && accountList.length === 0" style="color:#909399;font-size:12px;margin-top:4px;">输入用户ID并离开输入框后自动查询</div>
        </el-form-item>
        <el-form-item label="调整类型" prop="adjustType">
          <el-radio-group v-model="addForm.adjustType">
            <el-radio :label="1">增额</el-radio>
            <el-radio :label="2">减额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="调整金额" prop="adjustAmount">
          <el-input-number v-model="addForm.adjustAmount" :min="0.01" :precision="2" :step="100" style="width:100%;" placeholder="请输入金额"></el-input-number>
        </el-form-item>
        <el-form-item label="币种" prop="currency">
          <!-- 币种由所选关联账号带出、不允许手改：额度调整会直接改这个账号的余额，
               选成别的币种等于把钱记进另一个币种的账上 -->
          <el-input :value="addForm.currency" disabled placeholder="选择关联账号后自动带出"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="addForm.remark" rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addVisible=false">取消</el-button>
        <el-button type="primary" :loading="addSubmitting" :disabled="addSubmitting" @click="submitAdd">确认提交</el-button>
      </div>
    </el-dialog>

    <!-- 详情弹窗（只读） -->
    <el-dialog :visible.sync="detailVisible" width="640px" :close-on-click-modal="false" v-if="detail">
      <div slot="title"><h3 style="margin:0;">额度调整详情</h3></div>
      <!-- 基本信息 -->
      <div class="detail-section">
        <div class="detail-section-title">基本信息</div>
        <div class="detail-grid">
          <div class="detail-item"><div class="di-label">订单号</div><div class="di-value mono" style="color:var(--brand-primary);">{{ detail.orderNo }}</div></div>
          <div class="detail-item"><div class="di-label">用户ID</div><div class="di-value">{{ detail.customerNo }}</div></div>
          <div class="detail-item"><div class="di-label">姓名</div><div class="di-value">{{ detail.name || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">国家</div><div class="di-value">{{ detail.countryName || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">客户组</div><div class="di-value">{{ detail.groupName || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">调整类型</div><div class="di-value" :style="{color: detail.adjustType===1 ? '#16a34a' : '#dc2626'}">{{ detail.adjustTypeName }}</div></div>
        </div>
      </div>
      <!-- 金额信息 -->
      <div class="detail-section">
        <div class="detail-section-title">金额信息</div>
        <div class="detail-grid">
          <div class="detail-item"><div class="di-label">变动前额度</div><div class="di-value mono">${{ fmtMoney(detail.currentCredit) }}</div></div>
          <div class="detail-item"><div class="di-label">调整额度</div><div class="di-value mono" :style="{color: detail.adjustType===1 ? '#16a34a' : '#dc2626'}">{{ detail.adjustType===1 ? '+' : '-' }}{{ fmtMoney(detail.adjustAmount) }}</div></div>
          <div class="detail-item"><div class="di-label">变动后额度</div><div class="di-value mono">${{ fmtMoney(detail.afterCredit) }}</div></div>
          <div class="detail-item"><div class="di-label">币种</div><div class="di-value">{{ detail.currency || 'USD' }}</div></div>
        </div>
      </div>
      <!-- 时间信息 -->
      <div class="detail-section">
        <div class="detail-section-title">时间信息</div>
        <div class="detail-grid">
          <div class="detail-item"><div class="di-label">创建时间</div><div class="di-value">{{ fmtDateTime(detail.createDate) }}</div></div>
          <div class="detail-item"><div class="di-label">审核时间</div><div class="di-value">{{ detail.auditTime ? fmtDateTime(detail.auditTime) : '--' }}</div></div>
          <div class="detail-item"><div class="di-label">操作人</div><div class="di-value">{{ detail.reviewer || '--' }}</div></div>
          <div class="detail-item"><div class="di-label">审核备注</div><div class="di-value">{{ detail.auditRemark || '--' }}</div></div>
        </div>
      </div>
      <!-- 审核记录 -->
      <div class="detail-section">
        <div class="detail-section-title">审核记录</div>
        <div v-if="detail.logs && detail.logs.length" class="timeline">
          <div v-for="(l, i) in detail.logs" :key="i" class="tl-item">
            <div class="tl-dot" :style="{background: dotColor(l.actionType)}"></div>
            <div class="tl-content">
              <div class="tl-title">
                <span>{{ l.operator || '--' }} {{ l.actionTypeName }}</span>
                <el-tag :type="tlTagType(l.actionType)" size="mini">{{ l.actionTypeName }}</el-tag>
              </div>
              <div class="tl-time">{{ fmtDateTime(l.operateTime) }}</div>
              <div v-if="l.actionDetail" class="tl-detail">{{ l.actionDetail }}</div>
            </div>
          </div>
        </div>
        <div v-else style="font-size:12px;color:#9ca3af;">暂无审核记录</div>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 单条/批量拒绝弹窗 -->
    <el-dialog :visible.sync="rejectVisible" width="500px" :close-on-click-modal="false">
      <div slot="title"><h3 style="margin:0;">拒绝额度调整</h3></div>
      <div style="background:rgba(239,68,68,0.08);border:1px solid rgba(239,68,68,0.2);border-radius:6px;padding:10px 14px;font-size:12px;color:#b91c1c;margin-bottom:16px;">
        {{ rejectBatch ? '已选择 ' + selection.length + ' 条待审核记录' : '订单号：' + (rejectTarget ? rejectTarget.orderNo : '') }}
      </div>
      <el-form label-width="90px" size="small">
        <el-form-item label="审核备注">
          <el-input type="textarea" v-model="rejectRemark" rows="3" placeholder="请输入审核备注（选填）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"><el-button @click="rejectVisible=false">取消</el-button><el-button type="danger" @click="confirmReject">确定拒绝</el-button></div>
    </el-dialog>
  </div>
</template>

<script>
import { creditAdjustList, creditAdjustCounts, creditAdjustDetail, creditAdjustAdd, creditAdjustAudit, creditAdjustExport, creditAdjustAccounts } from '@/api/creditAdjustment'
import { customerGroupList } from '@/api/customerGroup'

export default {
  name: 'CreditAdjustmentList',
  data() {
    return {
      stats: {}, tableData: [], loading: false, total: 0,
      pageNum: 1, pageSize: 15, selection: [],
      activeTab: 'all',
      search: { orderNo: '', customerNo: '', name: '', groupName: '', adjustType: null, status: null, timeRange: null },
      groups: [],
      // addSubmitting：提交中标记，防重复点击导致同一笔额度调整提交多次（加金重复入账）
      // currency 不在表单里手选：由所选关联账号带出（USD/USC/CNY… 以账号为准），见 onAccountChange
      addVisible: false, addSubmitting: false, addForm: { customerNo: null, accountNo: null, adjustType: 1, adjustAmount: null, currency: '', remark: '' },
      accountList: [], accountLoading: false,
      addRules: {
        customerNo: [{ required: true, message: '请输入用户ID', trigger: 'blur' }],
        accountNo: [{ required: true, message: '请选择关联账号', trigger: 'change' }],
        adjustType: [{ required: true, message: '请选择调整类型', trigger: 'change' }],
        adjustAmount: [{ required: true, message: '请输入调整金额', trigger: 'change' }],
        // 只读字段：值为空说明所选账号在库里没配币种，提示直接指出原因，别让人对着灰框找不到可选项
        currency: [{ required: true, message: '所选账号未配置币种，无法提交', trigger: 'change' }]
      },
      detailVisible: false, detail: null,
      rejectVisible: false, rejectBatch: false, rejectTarget: null, rejectRemark: ''
    }
  },
  created() { this.fetchCounts(); this.fetchList(); this.fetchGroups() },
  methods: {
    fetchList() {
      this.loading = true
      const params = { pageNum: this.pageNum, pageSize: this.pageSize }
      Object.keys(this.search).forEach(k => {
        if (this.search[k] !== '' && this.search[k] !== null) params[k] = this.search[k]
      })
      if (params.timeRange && params.timeRange.length) {
        params.startTime = params.timeRange[0]
        params.endTime = params.timeRange[1]
      }
      delete params.timeRange
      if (this.activeTab === 'pending') params.status = 1
      else if (this.activeTab === 'passed') params.status = 2
      else if (this.activeTab === 'rejected') params.status = 3
      creditAdjustList(params).then(res => {
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
      }).finally(() => { this.loading = false })
    },
    fetchCounts() { creditAdjustCounts().then(res => { if (res.code === 0) this.stats = res.result || {} }) },
    fetchGroups() { customerGroupList({ pageNum: 1, pageSize: 500 }).then(res => { if (res.code === 0) this.groups = res.result.list || [] }) },
    searchList() { this.pageNum = 1; this.fetchList() },
    resetSearch() {
      this.search = { orderNo: '', customerNo: '', name: '', groupName: '', adjustType: null, status: null, timeRange: null }
      this.activeTab = 'all'; this.pageNum = 1; this.fetchList()
    },
    switchTab(tab) { this.activeTab = tab; this.pageNum = 1; this.fetchList() },
    handleSelectionChange(v) { this.selection = v },
    statusType(s) { const m = { 1: 'warning', 2: 'success', 3: 'danger' }; return m[s] || 'info' },
    fmtMoney(v) { return v === null || v === undefined || v === '' ? '0.00' : Number(v).toFixed(2) },
    signedMoney(row) { return (row.adjustType === 1 ? '+' : '-') + this.fmtMoney(row.adjustAmount) },
    fmtDateTime(t) { return t ? String(t).replace('T', ' ').substring(0, 19) : '--' },
    // 新增
    openAddModal() {
      this.addForm = { customerNo: null, accountNo: null, adjustType: 1, adjustAmount: null, currency: '', remark: '' }
      this.accountList = []; this.accountLoading = false
      this.addSubmitting = false
      this.addVisible = true
    },
    // 关联账号下拉选项文案：真实/钱包 + 账号号 + 币种
    // 币种必须显示 —— 同一客户可能有 USD 标准账号和 USC 美分账号，只看账号号分不出来，
    // 而下面的「币种」必须与所选账号一致，选错等于把钱加进另一个币种的账上
    accountLabel(a) {
      // const group = a.tradeGroupName ? '（' + a.tradeGroupName + '）' : ''
      const cur = a.currency ? ' (' + a.currency + ')' : ''
      return (a.accountTypeName || '账号') + ' ' + a.accountNo + cur
    },
    // 关联账号变化时带出该账号的币种（币种只读，必须与账号一致）
    onAccountChange(accountNo) {
      const acc = this.accountList.find(a => a.accountNo === accountNo)
      this.addForm.currency = acc && acc.currency ? acc.currency : ''
    },
    // 用户ID输入框失焦时，查询该用户的真实账号和钱包账号（不含模拟账号）
    queryAccounts() {
      const customerNo = this.addForm.customerNo
      if (!customerNo) { this.accountList = []; return }
      this.accountLoading = true
      this.addForm.accountNo = null
      // 换了用户就把账号和带出的币种一起清空，避免提交上一个用户的币种
      this.addForm.currency = ''
      creditAdjustAccounts(customerNo).then(res => {
        if (res.code === 0) this.accountList = res.result || []
        else this.accountList = []
      }).finally(() => { this.accountLoading = false })
    },
    submitAdd() {
      // 防抖/防重复提交：进入即同步置位，等校验完成再放行。
      // 校验回调是异步的（async-validator 走微任务），若把置位放在回调里，
      // 同一帧内的多次点击会全部通过入口判断、各自发起一次请求 —— 于是产生多条记录。
      // 校验不通过时再把标记复位，避免按钮一直锁住。
      if (this.addSubmitting) return
      this.addSubmitting = true
      this.$refs.addForm.validate(valid => {
        if (!valid) { this.addSubmitting = false; return }
        creditAdjustAdd(this.addForm).then(res => {
          if (res.code === 0) {
            this.$message.success('额度调整申请已提交，等待审核')
            this.addVisible = false; this.fetchList(); this.fetchCounts()
          } else this.$message.error(res.message || '操作失败')
        }).finally(() => { this.addSubmitting = false })
      })
    },
    // 详情（只读）
    openDetail(row) {
      creditAdjustDetail(row.id).then(res => {
        if (res.code === 0) {
          this.detail = res.result
          this.detailVisible = true
        } else this.$message.error(res.message || '加载失败')
      })
    },
    // 单条通过
    handleApprove(row) {
      this.$confirm('确认通过该额度调整申请？', '审核确认', { type: 'success' }).then(() => {
        creditAdjustAudit({ ids: [row.id], auditResult: 2 }).then(res => {
          if (res.code === 0) { this.$message.success('已通过'); this.fetchList(); this.fetchCounts() }
          else this.$message.error(res.message || '操作失败')
        })
      }).catch(() => {})
    },
    // 单条/批量拒绝
    openReject(row) {
      this.rejectBatch = false
      this.rejectTarget = row
      this.rejectRemark = ''
      this.rejectVisible = true
    },
    openBatchReject() {
      const pending = this.selection.filter(r => r.status === 1)
      if (!pending.length) { this.$message.warning('请勾选待审核的记录'); return }
      this.rejectBatch = true
      this.rejectRemark = ''
      this.rejectVisible = true
    },
    confirmReject() {
      const pending = this.rejectBatch ? this.selection.filter(r => r.status === 1) : [this.rejectTarget]
      const ids = pending.map(r => r.id)
      this.$confirm('确认拒绝选中的 ' + ids.length + ' 条额度调整申请？', '审核确认', { type: 'warning' }).then(() => {
        creditAdjustAudit({ ids, auditResult: 3, auditRemark: this.rejectRemark }).then(res => {
          if (res.code === 0) {
            this.$message.success('已拒绝')
            this.rejectVisible = false; this.fetchList(); this.fetchCounts()
          } else this.$message.error(res.message || '操作失败')
        })
      }).catch(() => {})
    },
    // 批量通过
    batchApprove() {
      const pending = this.selection.filter(r => r.status === 1)
      if (!pending.length) { this.$message.warning('请勾选待审核的记录'); return }
      this.$confirm('确认批量通过 ' + pending.length + ' 条额度调整申请？', '批量审批', { type: 'success' }).then(() => {
        creditAdjustAudit({ ids: pending.map(r => r.id), auditResult: 2 }).then(res => {
          if (res.code === 0) { this.$message.success('已批量通过'); this.fetchList(); this.fetchCounts() }
          else this.$message.error(res.message || '操作失败')
        })
      }).catch(() => {})
    },
    // 导出
    handleExport() {
      const params = {}
      Object.keys(this.search).forEach(k => {
        if (this.search[k] !== '' && this.search[k] !== null) params[k] = this.search[k]
      })
      if (params.timeRange && params.timeRange.length) {
        params.startTime = params.timeRange[0]
        params.endTime = params.timeRange[1]
      }
      delete params.timeRange
      if (this.activeTab === 'pending') params.status = 1
      else if (this.activeTab === 'passed') params.status = 2
      else if (this.activeTab === 'rejected') params.status = 3
      creditAdjustExport(params).then(res => {
        const blob = res instanceof Blob ? res : new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = '额度调整记录.xlsx'; a.click()
        window.URL.revokeObjectURL(url)
      })
    },
    dotColor(actionType) {
      const m = { 1: '#9ca3af', 2: '#16a34a', 3: '#dc2626', 4: '#e6a817' }
      return m[actionType] || '#9ca3af'
    },
    tlTagType(actionType) {
      const m = { 1: 'info', 2: 'success', 3: 'danger', 4: 'warning' }
      return m[actionType] || 'info'
    }
  }
}
</script>

<style scoped>
.page-container { background: #f4f6fb; min-height: calc(100vh - 84px); padding: 16px; }
.filter-bar { background: #fff; border-radius: 10px; padding: 14px 16px 4px; margin-bottom: 14px; box-shadow: 0 1px 3px rgba(0,0,0,0.04); }
.tabs-bar { display: flex; gap: 8px; margin-bottom: 14px; }
.tab-btn { padding: 8px 20px; border: 1px solid #d1d9e6; border-radius: 6px; background: #fff; font-size: 13px; color: #5a6578; cursor: pointer; transition: all 0.15s; }
.tab-btn:hover { background: #f0f2f5; color: #1a2236; }
.tab-btn.active { background: var(--brand-primary); color: #fff; border-color: var(--brand-primary); }
.table-wrapper { background: #fff; border-radius: 10px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.table-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.table-title { font-size: 15px; font-weight: 600; color: #1a2236; }
.table-actions { display: flex; gap: 8px; align-items: center; }
.btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 500; font-family: inherit; cursor: pointer; transition: all 0.15s; border: 1px solid transparent; white-space: nowrap; }
.btn-primary { background: var(--brand-primary); color: #fff; border-color: var(--brand-primary); }
.btn-danger { background: #f56c6c; color: #fff; border-color: #f56c6c; }
.btn-secondary { background: transparent; color: #5a6578; border-color: #e8ecf2; }
.btn-sm { padding: 5px 10px; font-size: 12px; }
.mono { font-family: 'JetBrains Mono', monospace; }
.detail-section { margin-bottom: 20px; }
.detail-section-title { font-size: 14px; font-weight: 600; color: #1a2236; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 1px solid #e8ecf2; }
.detail-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px; }
.detail-item { display: flex; flex-direction: column; gap: 4px; }
.di-label { font-size: 12px; color: #5a6578; }
.di-value { font-size: 14px; color: #1a2236; font-weight: 500; }
/* 审核记录时间线 */
.timeline { padding-left: 8px; }
.tl-item { display: flex; gap: 12px; position: relative; padding-bottom: 18px; }
.tl-item:not(:last-child)::before { content: ''; position: absolute; left: 4px; top: 12px; bottom: 0; width: 1px; background: #e8ecf2; }
.tl-dot { width: 9px; height: 9px; border-radius: 50%; margin-top: 5px; flex-shrink: 0; border: 2px solid #fff; box-shadow: 0 0 0 1px #e8ecf2; }
.tl-content { flex: 1; }
.tl-title { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 500; color: #1a2236; }
.tl-time { font-size: 11px; color: #9ca3af; margin-top: 2px; }
.tl-detail { font-size: 12px; color: #6b7280; margin-top: 4px; background: #f4f6fb; border-radius: 6px; padding: 6px 10px; word-break: break-all; }
</style>
